import {
  Box,
  Button,
  FormControlLabel,
  Popover,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material';
import { Fragment } from 'react';
import { KeywordOverviewTableTexts } from 'src/common/config/TextMessage';
import { KeywordOverviewTableCss } from './keywordOverview/keywordOverviewCSS';
import { keywordResearchDashBoardCss } from './keywordResearchCSS';

export const ExportCsvPopOver = ({
  open,
  id,
  anchorEl,
  handleClose,
  exportType,
  setExportType,
  customRange,
  setCustomRange,
  csvFormat,
  setCsvFormat,
  handleExport,
  isBackLink = false
}) => {
  return (
    <Fragment>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Box p={2} sx={KeywordOverviewTableCss?.mainExportBox}>
          <Typography sx={KeywordOverviewTableCss?.numberOfKeyword}>
            {isBackLink
              ? KeywordOverviewTableTexts?.numberOfBackLinks
              : KeywordOverviewTableTexts?.numberOfKeyword}
          </Typography>
          <RadioGroup
            value={exportType}
            onChange={(e) => setExportType(e.target.value)}
          >
            <FormControlLabel
              value="1000"
              control={<Radio />}
              label={
                <Typography sx={KeywordOverviewTableCss?.radioLabelText}>
                  {isBackLink
                    ? KeywordOverviewTableTexts?.exportFirstBackLinks
                    : KeywordOverviewTableTexts?.exportFirst}
                </Typography>
              }
            />
            <FormControlLabel
              value="custom"
              control={<Radio />}
              label={
                <Typography sx={KeywordOverviewTableCss?.radioLabelText}>
                  {KeywordOverviewTableTexts?.custom}
                </Typography>
              }
            />
          </RadioGroup>
          {exportType === 'custom' && (
            <TextField
              InputProps={{
                inputProps: { maxLength: 20 }
              }}
              autoComplete="off"
              sx={{
                ...KeywordOverviewTableCss?.customTextField,
                ...keywordResearchDashBoardCss?.hideArrowForTextFields,
                ...keywordResearchDashBoardCss?.removeBorderEffectForTextField
              }}
              type="number"
              value={customRange}
              onChange={(e) => setCustomRange(e.target.value)}
              placeholder="Enter number"
              fullWidth
              margin="normal"
            />
          )}

          <Box mt={2} display="flex" justifyContent="space-between">
            <Button
              onClick={handleClose}
              sx={KeywordOverviewTableCss?.exportBtn}
              variant="outlined"
            >
              {KeywordOverviewTableTexts?.cancel}
            </Button>
            <Button
              onClick={() => {
                handleExport();
              }}
              disabled={
                exportType === 'custom' && (!customRange || customRange == 0)
              }
              sx={KeywordOverviewTableCss?.exportBtn}
              variant="contained"
            >
              {KeywordOverviewTableTexts?.export}
            </Button>
          </Box>
        </Box>
      </Popover>
    </Fragment>
  );
};
